import useFieldFocus from '@v4/hooks/useFieldFocus'
import useEditorMeta from '@v4/hooks/useEditorMeta'
import { STATIC_CLASSES } from './Banner1.const'

export const useBanner1 = props => {
	const { metaData } = props

	const { handleFocus: handleButtonClick } = useFieldFocus({ metaData: metaData.buttonAction })
	const { handleFocus: handleTextClick } = useFieldFocus({ metaData: metaData.text })
	const { handleFocus: handleImageClick } = useFieldFocus({ metaData: metaData.backgroundImage })
	const { handleFocus: handleMobileImageClick } = useFieldFocus({ metaData: metaData.mobileImage })
	const { editable: textEditable, handleChange: handleTextChange } = useEditorMeta({
		metaData: metaData.text,
		key: 'text',
	})

	const { editable: buttonTextEditable, handleChange: handleButtonTextChange } = useEditorMeta({
		metaData: metaData.buttonText,
		key: 'buttonText',
	})

	return [
		{
			classes: STATIC_CLASSES,
			contentWidth: metaData.contentWidth?.metaValue,
			textShadow: metaData.textShadow?.toNumber(),
			opacity: metaData.opacity?.toNumber(),
			mobileOpacity: metaData.mobileOpacity?.toNumber(),
			backgroundImagePosition: metaData.backgroundImagePosition?.metaValue,
			direction: metaData.mobileImagePosition?.contentReverseDirection(),
			mobileImagePosition: metaData.mobileImagePosition?.metaValue,
			mobileAlignment: metaData.mobileAlignment?.metaValue,
			mobileButtonWidth: metaData.mobileButtonWidth?.metaValue,
			desktopImage: metaData.backgroundImage,
			mobileImage: metaData.mobileImage,

			text: metaData.text?.metaValue,
			textKey: metaData.text?.tierKey,
			textConfig: metaData.text?.config,
			textEditable,

			buttonText: metaData.buttonText?.metaValue,
			buttonTextKey: metaData.buttonText?.tierKey,
			buttonTextConfig: metaData.buttonText?.config,
			buttonAction: metaData.buttonAction?.metaValue,
			buttonLink: metaData.buttonLink?.metaValue,
			buttonTextEditable,
		},
		{
			handleMobileImageClick,
			handleImageClick,

			handleTextClick,
			handleTextChange,

			handleButtonClick,
			handleButtonTextChange,
		},
	]
}
